'use client';

import useEnhancedEffect from '@mui/utils/useEnhancedEffect';
export default useEnhancedEffect;